
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ProtectataMultiStopPage() {

  return (
      GenericProductPage(getProductByID(52),toAwning)
  )
}
